import React, { useEffect } from "react";
import "./NavBar.scss";
import logo from "../../../logo.svg";
import burger from "../../../images/burger-menu.svg";
import close from "../../../images/closeDark.svg"; // https://www.svgrepo.com/svg/380138/x-close-delete
import { ReactSVG } from "react-svg"; // https://www.npmjs.com/package/react-svg
import clsx from "clsx";
import { Link, useParams } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { useGlobalContext } from "../GlobalContext/context";

const NavBar = () => {
  const { openMenu, setOpenMenu } = useGlobalContext();
  // const isMobile = useMediaQuery("(max-width:769px)");
  const isTabletAndBelow = useMediaQuery("(max-width:1024px)");

  const { param } = useParams();

  //   const myFolder = 'myFolder';
  // const files = [];

  // // Get the list of files in the folder
  // const req = require.context(`../public/${myFolder}`, false, /\.txt$/);
  // req.keys().forEach((filename) => {
  //   files.push(filename);
  // });

  // console.log(files);
  useEffect(() => {
    if (openMenu) {
      document.body.classList.add("open-menu");
    } else {
      document.body.classList.remove("open-menu");
    }
  }, [openMenu]);

  function handleArrowDown(e) {
    if (e.key === "Tab") {
      if (
        e.target.classList.contains("mainCategory") &&
        !e.target.classList.contains("focus-on")
      ) {
        const mainCategories = document.querySelectorAll(".mainCategory");
        Array.from(mainCategories).map((item) => {
          item?.classList.remove("focus-on");
        });
        e.target.classList.add("focus-on");
      }
    }
  }

  const renderMenu = () => {
    return (
      <div className="menu-inner-wrap scrollbar">
        {/* <div tabindex={0} classname="maincategory" onkeydown={handlearrowdown}>
          <div
            classname={clsx(
              "main-link",
              param?.tolowercase() === "charitum" ? "underline" : ""
            )}
          >
            hotels
          </div>
          <div classname="placer"></div>
          <div classname="categories-wrap" tabindex={-1}>
            <div
              classname={clsx(
                "category-link",
                param?.tolowercase() === "charitum" ? "bold" : ""
              )}
            >
              <link
                onclick={() => setopenmenu(false)}
                to="category/hotels/charitum"
              >
                charitum
              </link>
            </div>
          </div>
        </div>   */}
        <div
          className="mainCategory"
          tabIndex={0}
          onKeyDown={handleArrowDown}
          tabIndex={0}
        >
          <div
            className={clsx(
              "main-link",
              param?.toLowerCase() === "evebands" ||
                param?.toLowerCase() === "goldia"
                ? "underline"
                : ""
            )}
          >
            Accessories
          </div>
          <div className="placer"></div>
          <div className="categories-wrap" tabIndex={-1}>
            {/* <div
              className={clsx(
                "category-link",
                param?.toLowerCase() === "evebands" ? "bold" : ""
              )}
            >
              <Link
                onClick={() => setOpenMenu(false)}
                to="Category/Accessories/EveBands"
              >
                EveBands
              </Link>
            </div> */}
            <div
              className={clsx(
                "category-link",
                param?.toLowerCase() === "goldia" ? "bold" : ""
              )}
            >
              <Link
                onClick={() => setOpenMenu(false)}
                to="Category/Accessories/Goldia"
              >
                Goldia
              </Link>
            </div>
          </div>
        </div>
        {/* <div className="mainCategory" tabIndex={0} onKeyDown={handleArrowDown}>
          <div
            className={clsx(
              "main-link",
              param?.toLowerCase() === "bulkbeefjerky" ? "underline" : ""
            )}
          >
            Food
          </div>
          <div className="placer"></div>
          <div className="categories-wrap"  tabIndex={-1}>
            <div
              className={clsx(
                "category-link",
                param?.toLowerCase() === "bulkbeefjerky" ? "bold" : ""
              )}
            >
              <Link
                onClick={() => setOpenMenu(false)}
                to="Category/Food/BulkBeefJerky"
              >
                Bulk Beef Jerky
              </Link>
            </div>
          </div>
        </div> */}
        {/* <div className="mainCategory" tabIndex={0} onKeyDown={handleArrowDown} tabIndex={0}>
          <div
            className={clsx(
              "main-link",
              param?.toLowerCase() === "rosewe" ? "underline" : ""
            )}
          >
            Clothes
          </div>
          <div className="placer"></div>
          <div className="categories-wrap" tabIndex={-1}>
            <div
              className={clsx(
                "category-link",
                param?.toLowerCase() === "rosewe" ? "bold" : ""
              )}
            >
              <Link
                onClick={() => setOpenMenu(false)}
                to="Category/Clothes/Rosewe"
              >
                Rosewe
              </Link>
            </div>
             <div
              className={clsx(
                "category-link",
                param?.toLowerCase() === "dresslily" ? "bold" : ""
              )}
            >
              <Link
                onClick={() => setOpenMenu(false)}
                to="Category/Clothes/DressLily"
              >
                DressLily
              </Link>
            </div>  
          </div>
        </div> */}
        <div
          className="mainCategory"
          tabIndex={0}
          onKeyDown={handleArrowDown}
          tabIndex={0}
        >
          <div
            className={clsx(
              "main-link",
              param?.toLowerCase() === "maven" ? "underline" : ""
            )}
          >
            Shoes
          </div>
          <div className="placer"></div>
          <div className="categories-wrap" tabIndex={-1}>
            <div
              className={clsx(
                "category-link",
                param?.toLowerCase() === "maven" ? "bold" : ""
              )}
            >
              <Link
                onClick={() => setOpenMenu(false)}
                to="Category/Shoes/Maven"
              >
                Maven
              </Link>
            </div>
          </div>
        </div>
        {/* <div className="mainCategory" tabIndex={0} onKeyDown={handleArrowDown} tabIndex={0}>
          <div
            className={clsx(
              "main-link",
              param?.toLowerCase() === "sense-u" ? "underline" : ""
            )}
          >
            Electronics
          </div>
          <div className="placer"></div>
          <div className="categories-wrap" tabIndex={-1}>
            <div
              className={clsx(
                "category-link",
                param?.toLowerCase() === "sense-u" ? "bold" : ""
              )}
            >
              <Link
                onClick={() => setOpenMenu(false)}
                to="Category/Electronics/Sense-U"
              >
                Sense-U
              </Link>
            </div>
          </div>
        </div> */}
        <div
          className="mainCategory"
          tabIndex={0}
          onKeyDown={handleArrowDown}
          tabIndex={0}
        >
          <div
            className={clsx(
              "main-link",
              param?.toLowerCase() === "auxbeam" ? "underline" : ""
            )}
          >
            Vehicules
          </div>
          <div className="placer"></div>
          <div className="categories-wrap" tabIndex={-1}>
            <div
              className={clsx(
                "category-link",
                param?.toLowerCase() === "auxbeam" ? "bold" : ""
              )}
            >
              <Link
                onClick={() => setOpenMenu(false)}
                to="Category/Vehicules/Auxbeam"
              >
                Auxbeam
              </Link>
            </div>
          </div>
        </div>
        <div
          className="mainCategory"
          tabIndex={0}
          onKeyDown={handleArrowDown}
          tabIndex={0}
        >
          <div
            className={clsx(
              "main-link",
              param?.toLowerCase() === "jackery" ? "underline" : ""
            )}
          >
            Solar
          </div>
          <div className="placer"></div>
          <div className="categories-wrap" tabIndex={-1}>
            <div
              className={clsx(
                "category-link",
                param?.toLowerCase() === "jackery" ? "bold" : ""
              )}
            >
              <Link
                onClick={() => setOpenMenu(false)}
                to="Category/Solar/Jackery"
              >
                Jackery
              </Link>
            </div>
          </div>
        </div>

        {/* <div className="mainCategory" tabIndex={0} onKeyDown={handleArrowDown} tabIndex={0}>
          <div
            className={clsx(
              "main-link",
              param?.toLowerCase() === "monspeakix" ? "underline" : ""
            )}
          >
            Camping
          </div>
          <div className="placer"></div>
          <div className="categories-wrap" tabIndex={-1}>
            <div
              className={clsx(
                "category-link",
                param?.toLowerCase() === "monspeakix" ? "bold" : ""
              )}
            >
              <Link
                onClick={() => setOpenMenu(false)}
                to="Category/Camping/monspeakix"
              >
                Mons peak ix
              </Link>
            </div>
          </div>
        </div> */}

        <div
          className="mainCategory"
          tabIndex={0}
          onKeyDown={handleArrowDown}
          tabIndex={0}
        >
          <div
            className={clsx(
              "main-link",
              param?.toLowerCase() === "overhalfsale" ? "underline" : ""
            )}
          >
            Mixed products
          </div>
          <div className="placer"></div>
          <div className="categories-wrap" tabIndex={-1}>
            <div
              className={clsx(
                "category-link",
                param?.toLowerCase() === "overhalfsale" ? "bold" : ""
              )}
            >
              <Link
                onClick={() => setOpenMenu(false)}
                to="Category/MixedProducts/Overhalfsale"
              >
                Overhalfsale
              </Link>
            </div>
          </div>
        </div>
        <div className="mainCategory" tabIndex={0} onKeyDown={handleArrowDown}>
          <div
            className={clsx(
              "main-link home-link",
              param === undefined ? "underline" : ""
            )}
          >
            <Link
              className="add-live-icon"
              onClick={() => setOpenMenu(false)}
              to="/EarthQuakePage"
            >
              Earthquakes
            </Link>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="main-header fix-inside">
      <header className={clsx(`header flex-it flex-align-item-center`)}>
        <div className="comp-wrap">
          <div className="comp-cont flex-it flex-align-item-center flex-justify-between">
            <Link
              onClick={() => setOpenMenu(false)}
              to="/"
              className="logo"
              aria-label="edrops logo"
            >
              <ReactSVG src={logo} />
            </Link>
            {isTabletAndBelow && !openMenu && (
              <ReactSVG
                className="icon-btn burger-btn"
                src={burger}
                onClick={() => setOpenMenu(true)}
              />
            )}
            {isTabletAndBelow && openMenu && (
              <ReactSVG
                className="icon-btn close-btn"
                src={close}
                onClick={() => setOpenMenu(false)}
              />
            )}
            <div className={clsx("categories-links", openMenu ? "show" : "")}>
              {renderMenu()}
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default NavBar;
